<template>
  <div>
    <v-container fluid class="pa-0">
      <v-row :class="{'flex-column': $vuetify.breakpoint.smAndDown}">
        <v-col cols="12" sm="12" md="2">
          <v-text-field
            v-model="search"
            label="Search..."
            prepend-icon="fas fa-search"
            clearable
          >
          </v-text-field>
        </v-col>
        <v-col cols="4" md="1">
        </v-col>
        <v-col cols="6" md="1">
          <div style="display: flex; justify-content: center; align-items: center">
            <v-btn text @click="refresh" v-if="!loading">
              <v-icon color="cyan darken-2">refresh</v-icon>
            </v-btn>
            <div v-if="loading" class="load-3">
              <div class="line"></div>
              <div class="line"></div>
              <div class="line"></div>
            </div>
          </div>
        </v-col>
        <v-col cols="4" md="2">
        </v-col>
        <v-col cols="4" md="2">
        </v-col>
        <v-col cols="4" md="2">
          <v-autocomplete
            label="Choose a depot..."
            :items="renderedDepots"
            item-text="name"
            item-value="id"
            v-model="depot"
            return-object
          ></v-autocomplete>
        </v-col>

        <v-col cols="4" md="2">
        </v-col>
      </v-row>
    </v-container>

    <v-divider></v-divider>

    <v-data-table
      :search="search"
      :headers="scheduleHeaders"
      :items="renderedProductionSchedule"
      :loading="loading"
    >
      <template v-slot:item="props">
        <tr v-bind:class="{odd: props.index % 2, even: !props.index % 2}">
          <td   style="text-align: center" v-for="(header, index) in scheduleHeaders" :key="index">
            {{props.item[header.value]}}
          </td>

        </tr>
      </template>
    </v-data-table>

  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: "ProductionSchedule",
  components: {

  },
  data(){
    return {
      ProductionScheduleDialog:false,
      ScheduleURL:'',
      search: '',
      loading: false,
      valid:false,
      reload: false,
      depot: {
        "id": 1,
        "region_id": 1,
        "region_name": "Sydney",
        "name": "Sydney",
        "address": "1 Charley Close",
        "address2": null,
        "suburb": "Pemulwuy",
        "state": "NSW",
        "postcode": "2456",
        "depot_code": "SYD",
        "wms": false,
        "parent_depot": 1,
        "active_phone_cap": 5,
        "latitude": null,
        "longitude": null,
        "r22_sys_id": 0
      },
      selectDays:[
        'Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'
      ],

      isVisible: false,
      scheduleHeaders:[
        {text: 'Id', value: 'id', align: 'center', sortable: true},
        {text: 'Client', value: 'client_name', align: 'center', sortable: true},
        {text: 'Day', value: 'day', align: 'center', sortable: false},
        {text: 'Climate', value: 'climateName', align: 'center', sortable: false},
        {text: 'Capacity', value: 'capacity', align: 'center', sortable: false}
      ],
    }

  },
  mounted: function () {
    this.timer = setInterval(() => {
      this.reload = !this.reload;
    }, 300000)
  },
  beforeDestroy () {
    clearInterval(this.timer)
  },
  computed: {
    isInternalUser() {
      return this.$store.getters['auth/isInternalUser'];
    },
    renderedProductionSchedule(){
      if (this.productionSchedule === null || this.productionSchedule === undefined) {
        return [];
      } else {
        this.getClimate(this.productionSchedule);
        if(this.isInternalUser){
          return this.productionSchedule;
        } else {
          this.productionSchedule.filter((item)=>{
            item.client_id = this.$store.getters['auth/client_id'];
          });
          return this.productionSchedule;
        }
      }
    },
    renderedDepots(){
      if (this.depots === null || this.depots === undefined) {
        return [];
      } else {
        return this.depots;
      }
    },
  },
  asyncComputed: {
    async productionSchedule() {
      if (this.reload || !this.reload) {
        this.loading = true;
        if(this.depot !== null) {
          this.ScheduleURL = '?depot_id=' + this.depot.id;
          return await axios.get(process.env.API_URL + '/productions/schedule' + this.ScheduleURL)
            .then((response) => {
              if (response.status === 200) {
                this.loading = false;
                return response.data;
              } else {
                this.loading = false;
                return [];
              }
            })
            .catch((error) => {
              this.loading = false;
              return [];
            });
        }
      }
    },
    async depots() {
      return await axios.get(process.env.API_URL +'/depots')
        .then((response) => {
          if (response.status === 200) {
            return response.data.sort((a, b) => (a.name > b.name) ? 1 : -1);
          } else {
            return [];
          }
        })
        .catch((error) => {
          return [];
        });
    },
  },
  methods: {
    getClimate(production) {
      let index;
      for (index in production) {
        production[index]['climateName'] = production[index]['climate']['name'];
      }
    },
    updateDataTable() {
      this.reload = !this.reload;
    },
    refresh() {
      setTimeout(() => this.isVisible = false, 1000);
      this.isVisible = true;
      this.reload = !this.reload;
    }
  }

}

</script>

<style scoped>
.line {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 15px;
  background-color: #6754a8;
}

@keyframes loadingC {
0 {transform: translate(0,0);}
50% {transform: translate(0,15px);}
100% {transform: translate(0,0);}
}

.load-3 .line:nth-last-child(1) {animation: loadingC .6s .1s linear infinite;}
.load-3 .line:nth-last-child(2) {animation: loadingC .6s .2s linear infinite;}
.load-3 .line:nth-last-child(3) {animation: loadingC .6s .3s linear infinite;}

</style>




// WEBPACK FOOTER //
// src/components/pages/Delivery/Production/ProductionSchedule.vue